export enum MetadataAssertionResult {
  Match,
  Mismatch,
  NotFound,
}
